<template>
  <div class="flex-row">
    <div @click="handleDownload" class="download-button tooltip-container" :class="{ 'loading': isLoading, 'has-label': !!label }">
      <img v-if="!isLoading" src="../assets/images/downloadOutline.svg" class="row-item-icon" />
      <span v-else class="spinner"></span>
      <span v-if="label" class="download-label">{{ label }}</span>
      <span v-if="!label" class="tooltip-text">{{$t('download_as_xlsx')}}</span>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  props: {
    // Doluysa ikon yerine etiketli düğme çizilir (tooltip taşmasını da önler).
    label: {
      type: String,
      default: ''
    },
    filename: {
      type: String,
      default: 'export'
    },
    data: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      required: true,
      default: () => []
    },
    computedFields: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    handleDownload() {
      if (this.isLoading) return;

      // Eğer data prop'u varsa doğrudan indir, yoksa event emit et
      if (this.data && this.data.length > 0) {
        this.processDownload(this.data);
      } else {
        this.$emit('download-requested');
      }
    },

    processDownload(data) {
      try {
        this.isLoading = true;

        const filteredData = this.filterData(data);

        this.exportToExcel(filteredData);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$emit('error', error);
      }
    },

    filterData(data) {
      return data.map(item => {
        const filteredItem = {};

        this.fields.forEach(field => {
          let value;

          if (this.computedFields[field]) {
            value = this.computedFields[field](item);
          } else {
            value = this.getNestedValue(item, field);
          }

          const headerName = this.headers[field] || field;
          filteredItem[headerName] = value;
        });

        return filteredItem;
      });
    },

    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, part) => acc?.[part], obj);
    },

    exportToExcel(data) {
      const ws = XLSX.utils.json_to_sheet(data);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Data');

      const fileName = `${this.filename}_${this.getFormattedDate()}.xlsx`;
      XLSX.writeFile(wb, fileName);

      this.$emit('downloaded', {
        filename: fileName,
        rowCount: data.length,
        fields: this.fields
      });
    },

    getFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    }
  }
}
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.download-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.download-button:active {
  transform: scale(0.95);
}

/* Etiketli hâl: diğer rapor sekmelerindeki "Raporu indir" düğmesiyle aynı ölçüler */
.download-button.has-label {
  height: 40px;
  padding: 0 16px;
  gap: 8px;
  border-radius: 8px;
  background: #111827;
  white-space: nowrap;
}

.download-button.has-label:hover {
  background: #1F2937;
}

.download-button.has-label .row-item-icon {
  filter: brightness(0) invert(1);
}

.download-label {
  font-family: 'euclid_medium', sans-serif;
  font-size: 11px;
  color: #fff;
}

.download-button.loading {
  opacity: 0.6;
  cursor: not-allowed;
}

.row-item-icon {
  width: 16px;
  height: 16px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #344054;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
